import React, { useState } from "react";
import GeniustextInput from "../utility/component/mastertext";
import AccountMasterHelp from "../help/listAccountMasterHelp";
import PurchaseBillHelp from "../help/purchaseBillHelp";
import { setAlertWithTitle, setSpinnerLoading } from "../utility/Redux/modal";
import { useDispatch, useSelector } from "react-redux";
import { selectPrefix, selectWidth } from "../utility/Redux/profile";
import OutlinedInputCustom from "../utility/component/textInput";
import DropdownWithSearch from "../utility/component/dropDown";
import StockHelp from "../help/stockHelp";
import { LoadBill } from "../CreateOrder/function";
import { selectToken } from "../utility/Redux/security";
import { getItemByCode } from "../utility/constant";
import { enterRowWithItemDetails } from "./fun";
import uniqeId from "uniqid";
import FirstIcodeItem from "./icodeEnterValue";
import moment from "moment";
import { CallAPIPromise } from "../billing/common";

const PartyDetails = ({
  partyDetails,
  setPartyDetails,
  expiryReportList,
  refreshList,
  setExpiryReportList,
  getBillData,
  loadPurchaseBill,
  duplicatePurchaseBill,
  accountMasterHelpStatus,
  setAccountMasterHelpStatus,
  BillModeOption,
  rows,
  delayedFunction,
  TaxTypeOption,
  setPurcahseAmtFocus,
  BillTypeOption,
  purchaseAmtRef,
  setInputRefFoucs,
  purchaseRef,
  partyRef,
  muiTextBox,
  setPurchaseBillNoFocus,
  partyNameRef,
  setPartyMasterCreaterModalStatus,
  setRows,
  setAlertTwoButtonModal,
  setSelectedTab,
  selectedTab,
}) => {
  const [purchaseBillHelpStatus, setPurchaseBillHelpStatus] = useState(false);
  const windowWidth = useSelector(selectWidth);
  const dispatch = useDispatch();
  const [stockHelpStatus, setStockhelpStatus] = useState(false);
  const [orderDetails, setOrderDetails] = useState("");
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  console.log(expiryReportList);
  return (
    <div>
      <div className="flex">
        <div>
          <div
            style={{
              textDecoration: "none",
              color: "black",
              fontSize: "14px",
              border: `1px ${selectedTab === 0 ? "solid" : "dotted"} gray`,
              marginRight: 3,
            }}
            onClick={() => {
              setSelectedTab(0);
            }}
            className="py-2 px-6 rounded-sm  "
          >
            Purchase
          </div>
        </div>
        <div
          style={{
            textDecoration: "none",
            color: "black",
            fontSize: "14px",
            border: `1px ${selectedTab === 1 ? "solid" : "dotted"} ${
              expiryReportList[0] ? "red" : "gray"
            } `,
            marginRight: 3,
          }}
          onClick={() => {
            setSelectedTab(1);
          }}
          className="py-2 px-6 rounded-sm  "
        >
          Expiry Report
        </div>
      </div>
      <div className="flex h-auto w-auto py-2  ">
        <div
          style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
          className="pt-3 px-3 pb-3   bg-[#ffffff]"
        >
          <div className="grid grid-cols-[160px,190px]  d:grid-cols-[200px,150px,180px] gap-3  w-full ">
            <OutlinedInputCustom
              readOnly={true}
              value={partyDetails.INVNO}
              label={"Serial No."}
              search={() => {
                if (true) {
                  setPurchaseBillHelpStatus(true);
                } else {
                  dispatch(
                    setAlertWithTitle({
                      title: "Alert",
                      msg: `You don't have permission to modify the purchase.`,
                    })
                  );
                }
              }}
            />
            <DropdownWithSearch
              options={BillModeOption}
              onChange={(t) =>
                setPartyDetails((e) => {
                  return {
                    ...e,
                    BILL_MODE: t,
                  };
                })
              }
              value={partyDetails.BILL_MODE}
              label={"Bill Mode"}
            />

            <DropdownWithSearch
              options={TaxTypeOption}
              onChange={(t) =>
                setPartyDetails((e) => {
                  return {
                    ...e,
                    TAX_TYPE: t,
                  };
                })
              }
              value={partyDetails.TAX_TYPE}
              label={"Tax Type"}
            />

            <DropdownWithSearch
              options={BillTypeOption}
              onChange={(t) =>
                setPartyDetails((e) => {
                  return {
                    ...e,
                    BILL_TYPE: t,
                  };
                })
              }
              value={partyDetails.BILL_TYPE}
              label={"Bill Type"}
            />

            <OutlinedInputCustom
              type={"date"}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (/^\d{4}-\d{2}-\d{2}$/.test(inputValue)) {
                  setPartyDetails((prevState) => ({
                    ...prevState,
                    DATE: inputValue,
                  }));
                }
              }}
              value={partyDetails.DATE}
              label={"Date"}
            />
          </div>
        </div>

        <div
          style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
          className=" bg-white grid grid-cols-[1fr,230px] 3xl:grid-cols-[600px,1fr,1fr] 2xl:grid-cols-[450px,1fr,1fr] ll:grid-cols-[1fr,160px,150px] gap-3 p-3 flex-1 ml-3"
        >
          <div className="flex ">
            <OutlinedInputCustom
              search={() => {
                setAccountMasterHelpStatus(true);
              }}
              onChange={() => {
                setAccountMasterHelpStatus(true);
              }}
              width={`calc(100% - 110px)`}
              value={partyDetails.NAME}
              label={"Party Name"}
              autoFucus={true}
              refrance={partyNameRef}
              onKeyDown={(e) => {
                if (e.code === "Enter" || e.code === "NumpadEnter") {
                  if (partyDetails.NAME) {
                    setPurchaseBillNoFocus(true);
                  } else {
                    setAccountMasterHelpStatus(true);
                  }
                }
              }}
            />

            <div className="ml-2">
              <OutlinedInputCustom
                type={"number"}
                readOnly={true}
                width={"110px"}
                value={partyDetails.ACCOUNT_NO}
                label={"Account No."}
              />
            </div>
          </div>

          <OutlinedInputCustom
            readOnly={true}
            type={"number"}
            value={partyDetails.MOBILE}
            label={"Mobile"}
          />

          <OutlinedInputCustom
            type={"date"}
            onChange={(e) => {
              const inputValue = e.target.value;
              if (/^\d{4}-\d{2}-\d{2}$/.test(inputValue)) {
                setPartyDetails((prevState) => ({
                  ...prevState,
                  PUR_BILL_DATE: inputValue,
                }));
              }
            }}
            value={partyDetails.PUR_BILL_DATE}
            label={"Bill Date"}
          />

          <div className="grid grid-cols-2">
            <OutlinedInputCustom
              readOnly={true}
              type={"text"}
              width={"100%"}
              value={partyDetails.TAX_NUMBER}
              label={"GST No."}
            />
            <div className="ml-2 flex flex-1">
              <OutlinedInputCustom
                search={() => {
                  if (partyDetails?.NAME) {
                    if (!rows.find((r) => r.ITEMNAME)) {
                      setStockhelpStatus(true);
                    }
                  } else {
                    dispatch(
                      setAlertWithTitle({
                        title: "Alert",
                        msg: "Please select party first",
                      })
                    );
                  }
                }}
                borderColor={"#e94a05"}
                onChange={() => {
                  if (partyDetails?.NAME) {
                    if (!rows.find((r) => r.ITEMNAME)) {
                      setStockhelpStatus(true);
                    }
                  } else {
                    dispatch(
                      setAlertWithTitle({
                        title: "Alert",
                        msg: "Please select party first",
                      })
                    );
                  }
                }}
                width={`calc(100% - 0px)`}
                value={rows[0]?.PO_NO > 0 ? rows[0]?.PO_NO : ""}
                label={"Order No."}
                autoFucus={true}
                refrance={partyNameRef}
                onKeyDown={(e) => {
                  if (e.code === "Enter" || e.code === "NumpadEnter") {
                    if (partyDetails.NAME) {
                      setPurchaseBillNoFocus(true);
                    } else {
                      if (partyDetails?.NAME) {
                        if (!rows.find((r) => r.ITEMNAME)) {
                          setStockhelpStatus(true);
                        }
                      } else {
                        dispatch(
                          setAlertWithTitle({
                            title: "Alert",
                            msg: "Please select party first",
                          })
                        );
                      }
                    }
                  }
                }}
              />
            </div>
          </div>

          <OutlinedInputCustom
            refrance={purchaseRef}
            onKeyDown={(e) => {
              if (e.code === "Enter" || e.code === "NumpadEnter") {
                setPurcahseAmtFocus(true);
              }
            }}
            id={"PUR_BILL_NO"}
            type={"text"}
            onChange={(e) => {
              if (true) {
                const isDuplicate = [];
                if (!isDuplicate[0]) {
                  setPartyDetails((o) => {
                    return {
                      ...o,
                      PUR_BILL_NO: e.target.value,
                    };
                  });
                } else {
                  dispatch(
                    setAlertWithTitle({
                      title: "Alert",
                      msg: "Already Exist this Nill No.",
                    })
                  );
                }
              }
            }}
            value={partyDetails.PUR_BILL_NO}
            label={"Purchase Bill No."}
          />

          <OutlinedInputCustom
            onKeyDown={(e) => {
              if (e.code === "Enter" || e.code === "NumpadEnter") {
                delayedFunction(rows[0].id);
              }
            }}
            refrance={purchaseAmtRef}
            type={"number"}
            onChange={(e) =>
              setPartyDetails((o) => {
                return {
                  ...o,
                  PUR_BILL_AMOUNT: e.target.value,
                };
              })
            }
            id={"PUR_BILL_AMOUNT"}
            onFocus={(e) => e.target.select()}
            value={partyDetails.PUR_BILL_AMOUNT}
            label={
              windowWidth <= 1300 ? "Purchase Bill Amt." : "Purchase Bill Amt."
            }
          />
        </div>

        <AccountMasterHelp
          onRowClick={(row) => {
            setAccountMasterHelpStatus(false);
            setPartyDetails((old) => {
              return {
                ...old,
                NAME: row.row.NAME,
                ADDRESS: row.row.ADDRESS,
                MOBILE: row.row.MOBILE,
                TAX_NUMBER: row.row.TAX_NUMBER,
                ACCOUNT_NO: row.row.ACCOUNT_NO,
              };
            });

            CallAPIPromise("/api/expiry/listExpiry", {
              table_prefix: prefix,
              ACCOUNT_NO: row.row.ACCOUNT_NO,
            }).then((res) => {
              if (res.status === 200) {
                setExpiryReportList(res.data.response.data);
              }
            });

            const nearestInput = document.getElementById("PUR_BILL_NO");
            // Focus on the nearest input if it exists
            if (nearestInput) {
              setTimeout(() => {
                nearestInput.focus();
              }, 200);
            }
          }}
          status={accountMasterHelpStatus}
          onClose={() => {
            setAccountMasterHelpStatus(false);
          }}
          onCreatePartyClick={() => {
            setPartyMasterCreaterModalStatus(true);
          }}
          refreshList={refreshList}
        />

        <StockHelp
          onRowClick={(p) => {
            setStockhelpStatus(false);
            setOrderDetails(p.row);
            dispatch(setSpinnerLoading("Loading"));
            LoadBill(
              prefix,
              token,
              dispatch,
              p.row.ORDER_NO,
              () => {},
              () => {},
              () => {},
              () => {},
              "",
              false,
              () => {}
            )
              .then((l) => {
                let list = [];
                for (let index = 0; index < l.length; index++) {
                  const item = l[index];
                  dispatch(setSpinnerLoading("Loading"));

                  const id = index === 0 ? rows[0].id : uniqeId();
                  getItemByCode(prefix, item.ICODE, token, dispatch, true)
                    .then((codeItem) => {
                      if (codeItem[0]) {
                        const qnty = item.QNTY;
                        const pur_price = codeItem[0].PUR_PRICE;
                        const diq_rate = 0;
                        const diq_amt = 0;
                        const tax1_rate = codeItem[0].TAX1_RATE;
                        const cess_rate = codeItem[0].CESS_RATE;
                        const tax2_rate = codeItem[0].TAX2_RATE;
                        const tax3_rate = codeItem ? 0 : codeItem[0].TAX3_RATE;
                        const vat_rate = 0;
                        const tcs_rate = 0;
                        const surcharge_rate = 0;

                        const EXP_DATE = "";

                        const i = FirstIcodeItem(
                          id,
                          qnty,
                          pur_price,
                          diq_rate,
                          diq_amt,
                          tax1_rate,
                          tax2_rate,
                          tax3_rate,
                          vat_rate,
                          tcs_rate,
                          surcharge_rate,

                          partyDetails,
                          codeItem[0],
                          EXP_DATE,
                          "",
                          cess_rate,
                          item.ORDER_NO
                        );
                        list.push(i);
                      }
                    })
                    .finally(() => {
                      if (list.length === l.length) {
                        setRows([
                          ...list,
                          {
                            id: uniqeId(),
                            INVNO: "",
                            DATE: moment().format("YYYY-MM-DD"),
                            PUR_BILL_NO: "",
                            PUR_BILL_DATE: moment().format("YYYY-MM-DD"),
                            PUR_BILL_AMOUNT: "0",
                            ENT_TIME: moment().format("YYYY-MM-DD"),
                            BILL_MODE: rows[0].BILL_MODE,
                            BILL_TYPE: rows[0].BILL_TYPE,
                            ACCOUNT_NO: "",
                            NAME: "",
                            ADDRESS: "",
                            MOBILE: "",
                            TAX_NUMBER: "",
                            ICODE: "",
                            ITEMNAME: "",
                            PACKING: "",
                            UNIT: "",
                            SECTION_NAME: "",
                            SUB_SEC_NAME: "",
                            BRAND_NAME: "",
                            PUR_PRICE: "0",
                            MRP_RATE: "0",
                            SALE_PRICE: "0",
                            QNTY: "0",
                            AMOUNT: "0",
                            DISQ_RT: "0",
                            DISQ_AMT: "0",
                            TAX1_RATE: "0",
                            TAX1_AMT: "0",
                            TAX2_RATE: "0",
                            TAX2_AMT: "0",
                            TAX3_RATE: "0",
                            TAX3_AMT: "0.00",
                            NET_AMT: "0.00",
                            BASIC_RATE: "0.00",
                            BASIC_AMT: "0.00",
                            TOTAL: "0",
                            FREIGHT: "0.00",
                            REMARKS: "",
                            ROUND_OFF: "0",
                            GTOTAL: "0",
                            HSN_CODE: "",
                            GR_NO: "0",
                            PO_NO: "0",
                            INCL_EXCL: "Excluded",
                            CESS_RATE: "0",
                            CESS_AMOUNT: "0",
                            TCS_RATE: "0",
                            TCS_AMOUNT: "0",
                            ADDITIONAL_CESS: "0",
                            VAT_AMOUNT: "0",
                            SURCHARGE_RATE: "0",
                            SURCHARGE_AMT: "0.00",
                            VAT_RATE: "0",
                            SCHEME_RATE: "0",
                            SCHEME_AMOUNT: "0.00",
                            TOTAL_SCHEME_AMOUNT: "0.00",
                            ADD_CHARGES: "0.00",
                            LESS_CHARGES: "0.00",
                            INCL_TAX: "No",
                            DEP_NAME: "",
                            PURCHASE_PIC: "",
                            EXP_DATE: "",
                            BATCH: "",
                            MARK_RATE: 0,
                            FREE_QNTY: 0,
                          },
                        ]);
                        dispatch(setSpinnerLoading(false));
                      }
                    });
                }

                dispatch(setSpinnerLoading(false));
              })
              .finally(() => {
                dispatch(setSpinnerLoading(false));
              });
          }}
          partyDetails={partyDetails}
          status={stockHelpStatus}
          onClose={() => {
            setStockhelpStatus(false);
          }}
        />
        <PurchaseBillHelp
          onRowClick={(row) => {
            delayedFunction(rows[0].id);
            setPurchaseBillHelpStatus(false);
            loadPurchaseBill(row.row.PUR_BILL_NO, row.row.ACCOUNT_NO);
          }}
          status={purchaseBillHelpStatus}
          onClose={() => {
            setPurchaseBillHelpStatus(false);
          }}
        />
      </div>
    </div>
  );
};

export default PartyDetails;
